import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router } from '@angular/router'
import { Observable } from 'rxjs'

import { FlashMessageService } from '../services/flash-message.service'
import { AuthService } from '../services/auth.service'

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private router: Router,
    private flashMessageService: FlashMessageService,
    private authService: AuthService
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isLoggedIn()) {
      return true
    }

    const queryParams = next.url && next.url.length ? { redirectTo: next.url[0].path } : {}

    this.router.navigate(['/login'], { queryParams })

    this.flashMessageService.info(
      'You need to be logged in to access this page.'
    )
    return false
  }
}
